(() => {
  const desktopQuery = window.matchMedia('(min-width: 750px)');

  const getMeaningfulChildren = (container) => {
    let children = Array.from(container.children).filter((item) => {
      return item.querySelector('img') || item.textContent.trim().length > 0;
    });

    if (
      children.length === 1 &&
      children[0].children.length > 0 &&
      !children[0].querySelector(':scope > img')
    ) {
      children = Array.from(children[0].children).filter((item) => {
        return item.querySelector('img') || item.textContent.trim().length > 0;
      });
    }

    return children;
  };

  const restoreSeedMainPage = (root) => {
    const content = root?.querySelector('[data-seed-main-page-content]');
    if (!content || !content.dataset.seedOriginalHtml) return;

    content.innerHTML = content.dataset.seedOriginalHtml;
    content.classList.remove('seed-main-page__content--features');
    root.classList.remove('seed-main-page--feature-grid');
    root.dataset.seedFormatted = 'false';
  };

  const formatSeedMainPage = (root) => {
    if (!root) return;

    const content = root.querySelector('[data-seed-main-page-content]');
    if (!content) return;

    if (!content.dataset.seedOriginalHtml) {
      content.dataset.seedOriginalHtml = content.innerHTML;
    }

    if (!desktopQuery.matches) {
      restoreSeedMainPage(root);
      return;
    }

    if (root.dataset.seedFormatted === 'true') return;

    content.innerHTML = content.dataset.seedOriginalHtml;

    const items = getMeaningfulChildren(content);
    const firstImageIndex = items.findIndex((item) => item.querySelector('img'));
    if (firstImageIndex < 0) return;

    const cards = [];
    const usedItems = new Set();

    for (let index = firstImageIndex; index < items.length && cards.length < 4; index += 1) {
      const media = items[index];

      if (!media.querySelector('img')) continue;

      const title = items[index + 1];
      const text = items[index + 2];

      if (!title || !text || title.querySelector('img') || text.querySelector('img')) continue;

      cards.push({ media, title, text });
      usedItems.add(media);
      usedItems.add(title);
      usedItems.add(text);
      index += 2;
    }

    if (cards.length < 4) return;

    const grid = document.createElement('div');
    grid.className = 'seed-main-page__feature-grid';

    cards.forEach((card) => {
      const item = document.createElement('article');
      item.className = 'seed-main-page__feature-card';

      const media = document.createElement('div');
      media.className = 'seed-main-page__feature-media';
      media.appendChild(card.media);

      const title = document.createElement('div');
      title.className = 'seed-main-page__feature-title';
      title.innerHTML = card.title.innerHTML;

      const text = document.createElement('div');
      text.className = 'seed-main-page__feature-text';
      text.innerHTML = card.text.innerHTML;

      item.append(media, title, text);
      grid.appendChild(item);
    });

    const body = document.createElement('div');
    body.className = 'seed-main-page__body rte';

    items.forEach((item) => {
      if (!usedItems.has(item)) body.appendChild(item);
    });

    content.textContent = '';
    content.classList.add('seed-main-page__content--features');
    content.appendChild(grid);

    if (body.children.length > 0) content.appendChild(body);

    root.classList.add('seed-main-page--feature-grid');
    root.dataset.seedFormatted = 'true';
  };

  const markSeedRichFeatureGrids = (scope = document) => {
    const sections = [];

    if (scope.matches?.('.shopify-section-rich-text, .shopify-section--rich-text')) {
      sections.push(scope);
    }

    scope.querySelectorAll('.shopify-section-rich-text, .shopify-section--rich-text').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      const grid = section.querySelector('.multi-column');
      section.classList.toggle('seed-rich-feature-grid', Boolean(grid && grid.querySelector('img')));
    });
  };

  const initSeedPageFormatting = (scope = document) => {
    if (scope.matches?.('[data-seed-main-page]')) formatSeedMainPage(scope);

    scope.querySelectorAll('[data-seed-main-page]').forEach(formatSeedMainPage);
    markSeedRichFeatureGrids(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSeedPageFormatting(), { once: true });
  } else {
    initSeedPageFormatting();
  }

  desktopQuery.addEventListener?.('change', () => initSeedPageFormatting());
  document.addEventListener('shopify:section:load', (event) => initSeedPageFormatting(event.target));
})();
